import {StyleSheet} from 'react-native';

import spacing from '@/constants/spacing';
import {createThemedStyles} from '@/theme';

export const styles = createThemedStyles(() => ({
  scrollViewContainer: {
    flexGrow: 1,
  },
  centered: {
    alignItems: 'center',
  },
  verticalArtworkCardWrapper: {
    flex: 1,
    alignItems: 'center',
  },
  verticalArtworkCard: {
    aspectRatio: 1,
    flex: 1,
    width: 'auto',
    maxWidth: '100%',
    overflow: 'hidden',
  },
  horizontalContainer: {
    flexDirection: 'row',
  },
  horizontalArtworkCardWrapper: {
    height: '100%',
    maxHeight: 100,
    alignSelf: 'stretch',
    aspectRatio: 1,
  },
  coverArt: {
    ...StyleSheet.absoluteFillObject,
    overflow: 'hidden',
  },
  playerProgressRow: {
    flexDirection: 'row',
  },
  playButton: {
    width: 24,
    height: 24,
    marginTop: spacing.xxs,
    marginLeft: spacing.s,
    marginRight: spacing.xs,
  },
  controlSmall: {
    paddingVertical: spacing.xs,
  },
}));
